import { withStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

export const LoginTextField = withStyles((theme: Theme) => ({
  root: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: "rgb(237, 236, 244)",
    "& .MuiFilledInput-underline:before": {
      borderBottom: 0,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottom: 0,
    },
    "& .MuiInputAdornment-root": {
      color: theme.palette.grey["600"],
    },
    "& .MuiFilledInput-root": {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
}))(TextField);
